module.exports = __webpack_public_path__ + "img/94be6ba.png";